"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.AuthorizingView = exports.mapDispatchToProps = exports.mapStateToProps = void 0;
var React = require("react");
var react_redux_1 = require("react-redux");
var react_router_dom_1 = require("react-router-dom");
var Types = require("types");
var sok_ui_1 = require("@caddigital/sok-ui");
var AuthActions = require("@caddigital/sok-reducers/lib/actions/auth/login");
var queryString = require("query-string");
var translate_1 = require("utils/translate");
require("./style.scss");
var mapStateToProps = function (state) {
    var selectedLanguage = (0, translate_1.getLanguage)();
    return {
        isLogin: state.auth.login.status,
        selectedLanguage: selectedLanguage
    };
};
exports.mapStateToProps = mapStateToProps;
var mapDispatchToProps = function (dispatch) { return ({
    dispatch: dispatch,
    exchangeTokens: function (x) {
        return dispatch(AuthActions.exchangeCodeForTokensRequest(x));
    }
}); };
exports.mapDispatchToProps = mapDispatchToProps;
var statePropsExtractable = Types.extractReturnType(exports.mapStateToProps);
var dispatchPropsExtractable = Types.extractReturnType(exports.mapDispatchToProps);
var enhance = (0, react_redux_1.connect)(exports.mapStateToProps, exports.mapDispatchToProps);
exports.AuthorizingView = enhance(/** @class */ (function (_super) {
    __extends(AuthorizingViewComponent, _super);
    function AuthorizingViewComponent(props) {
        var _this = _super.call(this, props) || this;
        _this.state = {
            hasError: false
        };
        return _this;
    }
    AuthorizingViewComponent.prototype.componentWillMount = function () {
        var parsed = queryString.parse(location.search);
        if (parsed.code && parsed.state) {
            this.props.exchangeTokens({
                code: parsed.code,
                state: parsed.state,
                redirect_uri: "".concat(__SSO_REDIRECT__, "/authorizing")
            });
        }
        else {
            this.setState({ hasError: true });
        }
    };
    AuthorizingViewComponent.prototype.render = function () {
        if (this.state.hasError || this.props.isLogin === 'FAILED') {
            return (React.createElement("div", { className: 'authorizing-view' },
                React.createElement("h2", null, "Authorization failed"),
                React.createElement(react_router_dom_1.Link, { to: "/".concat(this.props.selectedLanguage, "/login") }, "Please login again")));
        }
        return (React.createElement("div", { className: 'authorizing-view' },
            React.createElement(sok_ui_1.LoadingSpinner, null),
            "Please wait..."));
    };
    return AuthorizingViewComponent;
}(React.PureComponent)));
exports.default = exports.AuthorizingView;
